import { Injectable } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Service } from '@dgx-pr-spa/shared/util';
import { Store } from '@ngrx/store';
import * as fromAdditionalServices from '../store/actions';
import * as fromAdditionalServicesState from '../store/reducers';
import * as fromAdditionalServicesQuery from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class AdditionalServicesService {
  constructor(
    public readonly store?: Store<fromAdditionalServicesState.AdditionalServicesState>,
    public readonly fb?: UntypedFormBuilder
  ) {}

  readonly upsellEnabled$ = this.store.select(
    fromAdditionalServicesQuery.getUpsellEnabled
  );

  readonly itemOfferState$ = this.store.select(
    fromAdditionalServicesQuery.getItemOfferState
  );
  readonly itemOffer$ = this.store.select(
    fromAdditionalServicesQuery.getItemOffer
  );

  readonly itemOfferError$ = this.store.select(
    fromAdditionalServicesQuery.getItemOfferError
  );

  readonly itemOfferLoading$ = this.store.select(
    fromAdditionalServicesQuery.getItemOfferLoading
  );

  readonly itemOfferLoaded$ = this.store.select(
    fromAdditionalServicesQuery.getItemOfferLoaded
  );

  readonly itemOfferUpsell$ = this.store.select(
    fromAdditionalServicesQuery.getItemOfferUpsell
  );

  readonly extras$ = this.store.select(fromAdditionalServicesQuery.getExtras);

  readonly isInstallationSelected$ = this.store.select(
    fromAdditionalServicesQuery.isInstallationSelected
  );
  readonly isDisposalSelected$ = this.store.select(
    fromAdditionalServicesQuery.isDisposalSelected
  );
  readonly isDeliverySelected$ = this.store.select(
    fromAdditionalServicesQuery.isDeliverySelected
  );
  readonly isProtectionSelected$ = this.store.select(
    fromAdditionalServicesQuery.isProtectionSelected
  );
  readonly isDeclineProtectionSelected$ = this.store.select(
    fromAdditionalServicesQuery.isDeclineProtectionSelected
  );
  readonly isTermsConditionsSelected$ = this.store.select(
    fromAdditionalServicesQuery.isTermsConditionsSelected
  );
  readonly isInstallationAvailable$ = this.store.select(
    fromAdditionalServicesQuery.isInstallationAvailable
  );
  readonly isDisposalAvailable$ = this.store.select(
    fromAdditionalServicesQuery.isDisposalAvailable
  );
  readonly isDeliveryAvailable$ = this.store.select(
    fromAdditionalServicesQuery.isDeliveryAvailable
  );
  readonly getInstallation$ = this.store.select(
    fromAdditionalServicesQuery.getInstallation
  );
  readonly getDisposal$ = this.store.select(
    fromAdditionalServicesQuery.getDisposal
  );
  readonly getDelivery$ = this.store.select(
    fromAdditionalServicesQuery.getDelivery
  );

  readonly isInstallationUpsellAvailable$ = this.store.select(
    fromAdditionalServicesQuery.isInstallationUpsellAvailable
  );
  readonly isDisposalUpsellAvailable$ = this.store.select(
    fromAdditionalServicesQuery.isDisposalUpsellAvailable
  );

  readonly isUpsellAvailable$ = this.store.select(
    fromAdditionalServicesQuery.isUpsellAvailable
  );

  resetProtection() {
    this.store.dispatch(fromAdditionalServices.resetProtection());
  }

  agreeTermsConditions() {
    this.store.dispatch(fromAdditionalServices.agreeTermsConditions());
  }

  resetTermsConditions() {
    this.store.dispatch(fromAdditionalServices.resetTermsConditions());
  }

  declineProtection() {
    this.store.dispatch(fromAdditionalServices.declineProtection());
  }

  resetDeclineProtection() {
    this.store.dispatch(fromAdditionalServices.resetDeclineProtection());
  }
  addExtra(payload: Service) {
    this.store.dispatch(fromAdditionalServices.addExtra({ payload }));
  }

  removeExtra(payload: Service) {
    this.store.dispatch(fromAdditionalServices.removeExtra({ payload }));
  }

  resetExtras() {
    this.store.dispatch(fromAdditionalServices.resetExtras());
  }

  addProtection() {
    this.store.dispatch(fromAdditionalServices.addProtection());
  }

  loadItemOffer() {
    this.store.dispatch(fromAdditionalServices.loadItemOffer());
  }
}
